export enum FlexBoxValues {
  flexEnd = 'flex-end',
  justifyCenter = 'center',
  alignCenter = 'center',
}
